import { memo, FC, useMemo, useState, useCallback, useContext } from 'react'
import { ScreenContext } from 'react-components'
import Searchbar from '../searchbar'
import HeaderSection from '../../common/header-section'
import { SearchbarFieldsReturn } from '../hooks/use-searchbar'
import NavigationSectionTransport from '../../../transports/common/navigation-section-transport'
import { RegionNodeTransport } from '../../../transports/property-details-page-transport'
import PreviewHeader from './preview-header'
import { AB_KEY, AB_VARIANT_VERSION, WORLD_REGION_NODE_ID } from '../../../common/constants'
import { useRouter } from 'next/router'
import { MegabarTransport } from '../../../transports/common/megabar-transport'
import { useABVariant } from '../../../utils/hooks'

type HeaderSearchBarProps = {
    isLoggedIn: boolean
    userDetails: any
    url: string
    navigationSection: NavigationSectionTransport
    searchbar: SearchbarFieldsReturn
    listingId?: string
    regionNode: RegionNodeTransport
    petsAllowed: boolean
    megabar?: MegabarTransport
    hideListRental?: boolean
}

const HeaderSearchbar: FC<HeaderSearchBarProps> = ({
    isLoggedIn,
    userDetails,
    url,
    navigationSection,
    searchbar,
    listingId,
    regionNode,
    petsAllowed,
    megabar,
    hideListRental,
}) => {
    const { query } = useRouter()
    const { isMobile } = useContext(ScreenContext)
    const [isAllInputModalOpen, setAllInputModal] = useState<boolean>(false)
    const { isProvidedVariantActive: isSearchbarHiddenVariantActive } = useABVariant(
        AB_KEY.PDP_HIDE_SEARCHBAR,
        AB_VARIANT_VERSION.ONE,
    )

    const toggleAllInputModal = useCallback(() => {
        setAllInputModal((prev: boolean) => !prev)
    }, [])

    const headerSection = useMemo(
        () => ({
            navigationSectionResponse: navigationSection,
        }),
        [navigationSection],
    )

    const isPreviewMode = useMemo(() => query && query['preview'], [query])

    const searchRegionNode = useMemo(
        () => ({
            arrival: searchbar.arrival?.toDateString(),
            departure: searchbar.departure?.toDateString(),
            search: searchbar.location,
            adults: searchbar.adults,
            children: searchbar.kids,
            regionNodeId: regionNode?.id || WORLD_REGION_NODE_ID,
        }),
        [regionNode?.id, searchbar.adults, searchbar.arrival, searchbar.departure, searchbar.kids, searchbar.location],
    )

    return (
        <>
            {isPreviewMode ? (
                <PreviewHeader listingId={listingId ? listingId : ''} />
            ) : (
                <HeaderSection
                    isLoggedIn={isLoggedIn}
                    firstName={userDetails?.firstName}
                    url={url}
                    headerSection={headerSection}
                    onSearchIconClick={isSearchbarHiddenVariantActive ? undefined : toggleAllInputModal}
                    isAllInputModalOpen={isAllInputModalOpen}
                    showVacationIdeasNavButton
                    searchRegionNode={searchRegionNode}
                    showSearchbar={!isSearchbarHiddenVariantActive}
                    showNavigationLinks={false}
                    megabar={megabar}
                    hideListRental={hideListRental}
                />
            )}
            {isMobile && !isSearchbarHiddenVariantActive && (
                <Searchbar
                    searchRegionNode={searchRegionNode}
                    onSearchIconClick={toggleAllInputModal}
                    isAllInputModalOpen={isAllInputModalOpen}
                    petsAllowed={petsAllowed}
                />
            )}
        </>
    )
}

export default memo(HeaderSearchbar)
